export default __webpack_public_path__ + "static/media/Acer S277HK.f556b30d.png";